// extracted by mini-css-extract-plugin
export default {"wrapper":"RecentDesign_wrapper__wyY73","gridWrapper":"RecentDesign_gridWrapper__5fYHL","one_card_wrapper":"RecentDesign_one_card_wrapper__QHYuO"};